import CommonStyles from 'shared/style/commonPageStyles'
import styled from 'styled-components'

const Style = {
	Wrapper: CommonStyles.PageWrapper,
	SubHeaderContainer: styled.div`
		display: flex;
		padding-bottom: 20px;
		border-bottom: 1px solid ${({theme}) => theme.color.grey4};
	`,
	EventName: styled.p`
		${({theme}) => theme.font.small_bold};
		text-align: left;

		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			font-size: 14px;
		}
	`,
}

export default Style
